import React from 'react'
import { Link } from 'react-router'
import { Container, Row, Col, Button, FormGroup } from 'reactstrap';
import { Field } from 'redux-form'


import { renderInput, renderInputUpperCase, renderSelect } from '../../utils/forms/renderers'
import { isRequired, isEmail, minLength} from '../../utils/forms/validators'
import Loader from '../../core/components/Loader'
import { ButtonLoader } from '../../utils/loader'
import '../styles/style.css';
import '../styles/form.css';

class FormStepOne extends React.Component {

	constructor(props) {
        super(props);
    }

   componentDidMount() {
      this.props.listRegion()
   }

    render() {
    	const { provider, closePage, user, newLead } = this.props
        const { handleSubmit, pristine, submitting, regions, submitSucceeded } = this.props

    	return (
            <div>
                <form role="form">
                    <div className="provider-bloc-form">
                        <Row>
                            <Col>
                                <div className="title"> Contact </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs="12" sm="6">
                              <Field
                                name="last_name"
                                component={renderInputUpperCase}
                                validate={isRequired}
                                label="Nom*" />
                            </Col>

                            <Col xs="12" sm="6">
                                <Field
                                  name="first_name"
                                  component={renderInputUpperCase}
                                  validate={isRequired}
                                  label="Prénom*" />
                            </Col>
                          </Row>

                          <Row>
                              <Col>
                                <Field
                                  name="username"
                                  type="email"
                                  component={renderInput}
                                  validate={[isRequired, isEmail]}
                                  label="Email*" />
                              </Col>
                          </Row>

                          <Row>
                              <Col>
                                <Field
                                  name="password"
                                  type="password"
                                  component={renderInput}
                                  validate={newLead ? isRequired : minLength(6)}
                                  label="Mot de passe" />
                              </Col>
                          </Row>

                          <Row>
                              <Col>
                                <Field
                                  name="phone"
                                  component={renderInput}
                                  validate={[isRequired, minLength(10)]}
                                  maxlength="10"
                                  label="Téléphone*" />
                              </Col>
                          </Row>

                        {user.role !== "provider" &&
                            <Row>
                                <Col>
                                    <Field
                                        name="region"
                                        component={renderSelect}
                                        validate={isRequired}
                                        options={newLead ? user.regions : regions.list}
                                        label="Région*"/>
                                </Col>
                            </Row>
                        }
                    </div>

                    <div>
                     <Row className="form-btn">

                        {this.props.create &&
                          <Col className="center">
                            {submitting &&
                              <ButtonLoader />
                            ||
                              <FormGroup>
                                  <Button className="btn-green" onClick={handleSubmit}>Etape suivante</Button>
                              </FormGroup>
                            }
                          </Col>
                        }

                        {!this.props.create &&
                          <Col className="center">
                            <FormGroup>

                              <Button className="btn-transparent" onClick={closePage}>{submitSucceeded && "Retour à la fiche" || "Annuler"}</Button>

                              {submitting &&
                                <ButtonLoader />
                              ||
                                <Button className="btn-green" onClick={handleSubmit} >Enregistrer</Button>
                              }

                            </FormGroup>
                          </Col>
                        }


                      </Row>
                    </div>

                    <div className="provider-bloc-note">
                        * Champs obligatoires
                    </div>
                    <div className="provider-bloc-note">
                        Les informations recueillies sont nécessaires à HomeServe pour la gestion de votre candidature à notre réseau de prestataires agréé grâce à la création de votre compte prestataire.
                        Pour plus d’informations, consultez notre <a href={"https://homeserve.fr/politique-protection-donnees-personnelles"}> Politique de données personnelles. </a>
                        Conformément à la règlementation, vous bénéficiez d’un droit d’accès, de rectification, de limitation, de portabilité, d’effacement et d’opposition à l’utilisation de vos données personnelles ainsi que du droit de formuler des directives concernant la gestion de vos données post mortem.
                        Vous pouvez exercer ces droits en vous adressant auprès de HomeServe – Service Clients – TSA 82111 – 69303 Lyon Cedex 07 ou par mail à webmestre@homeserve.fr
                    </div>
                </form>
            </div>
        )
    }
}


export default FormStepOne



// WEBPACK FOOTER //
// ./src/provider/components/FormStepOne.js